import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import GearRatioCalculator from '../components/tools/GearRatioCalculator';

const GearRatioCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="gear-ratio-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Gear Ratio & Final Drive Ratio Calculator"
        description="Calculate and visualize how transmission gear ratios and final drive ratio relate engine/motor RPM to wheel speed and vehicle speed, per gear."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="gear-ratio-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <GearRatioCalculator />
          <ToolGuideCta guidePath="/tools/gear-ratio-calculator/guide" toolName="Gear Ratio & Final Drive Ratio Calculator" />
        </div>
      </section>
    </div>
  );
};

export default GearRatioCalculatorPage;
